module.exports = __webpack_public_path__ + "img/frame (78).caafbf2f.jpg";